import { BasicModel } from './basic.model';

export class LangLineModel {
  public action: string;
  public rightId: number;
  constructor(public id: number = null,
              public selected: any = new BasicModel(),
              public dubbing: boolean = false,
              public subtitle: boolean = false,
              public checked: boolean = false,
              public allLanguages: boolean = false,
              public included: BasicModel[] = [],
              public excluded: BasicModel[] = [],
              public toRemove: BasicModel[] = [],
              public excludedStr: string = null) {
  }

  public getAllIdExcluded(): number[] {
    return this.excluded.map((x) => x.id);
  }

  public fromJSON(json) {
    for (let propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
